/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable-next-line jsx-a11y/anchor-is-valid

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer" id="">
      <div className="col-12 d-flex justify-content-between footer-row d-md-none">
        <div className="font_small">
          <p className="m-1">
            © {new Date().getFullYear()} Tizeti Network Ghana Limited <br />
            Plot 231, Bissau Avenue, East Legon, Accra
          </p>
        </div>
        <div className="social_media mt-1">
          <Link to="#">
            <i className="fab fa-facebook-f mr-2" />
          </Link>
          <Link to="#">
            <i className="fab fa-twitter mr-2" />
          </Link>
          <Link to="#">
            <i className="fab fa-instagram mr-2" />
          </Link>
          <Link to="#">
            <i className="fab fa-linkedin mr-2" />
          </Link>
        </div>
      </div>

      <div className="d-none d-md-flex">
        <div className="col-12 d-flex justify-content-between footer-row">
          <div className="font_12 mt-2">
            <p className="m-0 mb-1">
              © {new Date().getFullYear()} Tizeti Network Ghana Limited <br />
              Plot 231, Bissau Avenue, East Legon, Accra
            </p>
          </div>

          <div className="social_media mt-2">
            <Link to="#">
              <i className="fab fa-facebook-f ml-3" />
            </Link>
            <Link to="#">
              <i className="fab fa-twitter ml-3" />
            </Link>
            <Link to="#">
              <i className="fab fa-instagram ml-3" />
            </Link>
            <Link to="#">
              <i className="fab fa-linkedin ml-3" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
